import React from 'react';
import { Button, Card, Space, Tag, Typography } from 'antd';
import { CheckCircleFilled, FilePdfOutlined, FileTextOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { DocumentTraining } from '../utils/trainingDocuments';
import { formatTrainingDate } from '../utils/trainingDates';

const DocumentTrainingCard: React.FC<{ training: DocumentTraining; folderTitle?: string }> = ({ training, folderTitle }) => {
  const navigate = useNavigate();
  const mainDocument = training.documents.find(document => document.document_kind === 'presentation') || training.documents[0];
  return <Card className="document-training-card">
    {folderTitle && <Typography.Text type="secondary" className="document-training-folder">{folderTitle}</Typography.Text>}
    <Space wrap className="document-training-heading">
      <Typography.Title level={4}>{training.title}</Typography.Title>
      {training.isCompleted && <Tag icon={<CheckCircleFilled />} color="success">Изучено</Tag>}
    </Space>
    <Typography.Paragraph type="secondary">Дата обучения: {formatTrainingDate(training.trainingDate)}</Typography.Paragraph>
    {mainDocument && <Button type="primary" onClick={() => navigate(`/videos/documents/${mainDocument.id}`)}>Открыть обучение</Button>}
    <div className="document-training-files">
      {training.documents.map(document => <div key={document.id} className="document-training-file">
        <Button type="link" icon={document.document_kind === 'presentation' ? <FilePdfOutlined /> : <FileTextOutlined />} onClick={() => navigate(`/videos/documents/${document.id}`)}>
          {document.document_kind === 'presentation' ? 'Презентация' : 'Транскрибация'}
        </Button>
        <Typography.Text type="secondary" className="document-training-filename">{document.title}</Typography.Text>
        {document.progress?.is_completed && <Tag color="success">Прочитано</Tag>}
      </div>)}
    </div>
  </Card>;
};

export default DocumentTrainingCard;
